import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

/** State of the current table logic */

/** Creates an entity adapter to store a map with all the table rows that are going to be updated */
export const TableAdapter = createEntityAdapter({
  selectId: fetchingItem => fetchingItem.id
});
const initialState = {
  ...TableAdapter.getInitialState(),
  tableType: null,
  bulkActionName: null,
  bulkActionResults: {
    numberOfErrors: 0,
    numberOfSuccess: 0
  },
  allowedBulkButtonsInSession: [],
  filterMenu: {
    isOpen: false,
    anchorPosition: {
      top: 0,
      left: 0
    },
    originalColumnPreferences: undefined
  }
};

/** Slice to access state of table */
const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    /** Remove single entity based on the provided ID before fetching and manually */
    removeOneManually(state, action) {
      TableAdapter.removeOne(state, action.payload);
      state.bulkActionResults = {
        numberOfErrors: 0,
        numberOfSuccess: 0
      };
      if (state.ids.length === 0) {
        state.bulkActionName = null;
      }
    },
    /** Remove single entity based on the provided ID after fetching done */
    removeOneAfterFetching(state, action) {
      TableAdapter.removeOne(state, action.payload);
    },
    /** Update single entity based on the provided ID and changes */
    updateOne: TableAdapter.updateOne,
    /** Update multiple entity based on the provided IDs and changes */
    updateMany: TableAdapter.updateMany,
    /** Set the initial fetching items */
    setInitialFetchingItems(state, action) {
      TableAdapter.setAll(state, action.payload.map(id => {
        return {
          id: id.toString(),
          status: "idle",
          message: ""
        };
      }));
    },
    /**
     * Change the status of all the provided items if the status is not "not-allowed".
     * It will also clear the message if requested.
     */
    changeAllFetchingStatus(state, action) {
      TableAdapter.setAll(state, TableAdapter.getSelectors().selectAll(state).map(item => {
        return {
          ...item,
          status: item.status !== "not-allowed" ? action.payload.status : item.status,
          message: action.payload.shouldClearMessage ? "" : item.message
        };
      }));
    },
    setTableType(state, action) {
      state.tableType = action.payload;
    },
    setBulkActionResults(state, action) {
      state.bulkActionResults = action.payload;
    },
    /** Set the allowed bulk actions */
    setAllowedBulkButtonsInSession(state, action) {
      state.allowedBulkButtonsInSession = action.payload;
    },
    setBulkActionName(state, action) {
      if (action.payload === null) {
        state.bulkActionName = null;
        state.allowedBulkButtonsInSession = [];
        state.bulkActionResults = {
          numberOfErrors: 0,
          numberOfSuccess: 0
        };
        TableAdapter.setAll(state, TableAdapter.getSelectors().selectAll(state).map(item => {
          return {
            ...item,
            status: "idle",
            message: ""
          };
        }));
      } else {
        state.bulkActionName = action.payload;
      }
    },
    /** Reset the whole table slice */
    resetTableState: () => initialState,
    setIsFilterMenuOpen(state, action) {
      state.filterMenu.isOpen = action.payload;
    },
    /** Set the snapshot of column preferences when menu is opened */
    setOriginalColumnPreferences(state, action) {
      state.filterMenu.originalColumnPreferences = action.payload;
    },
    setFilterMenuAnchorPosition(state, action) {
      state.filterMenu.anchorPosition = action.payload;
    }
  }
});
export const {
  updateOne,
  updateMany,
  removeOneManually,
  removeOneAfterFetching,
  setInitialFetchingItems,
  setTableType,
  setBulkActionName,
  setBulkActionResults,
  changeAllFetchingStatus,
  setAllowedBulkButtonsInSession,
  resetTableState,
  setIsFilterMenuOpen,
  setFilterMenuAnchorPosition,
  setOriginalColumnPreferences
} = tableSlice.actions;
export const tableReducer = tableSlice.reducer;